
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"5","cy":"5","r":"4.25","fill":"none"}}),_c('path',{attrs:{"d":"M4.17 4.17a.583.583 0 00-.12.65l6.594 14.834a.583.583 0 001.069-.008l2.379-5.555 5.556-2.38a.583.583 0 00.006-1.068L4.82 4.05a.583.583 0 00-.648.12H4.17z"}})])
          )
        }
      }
    